import { useNavigate } from "react-router-dom";
import { useSelectedDashboardDispatch } from "../../../contexts/SelectedDashboardContext";
import useCreateDashboardUserSettings from "../../../apiCalls/dashboardusersettings";
import { useAuthStore } from "../../../contexts/AuthContext";
import { useWorkspaceDispatch } from "../../../contexts/WorkspaceContext";
import { useDashboardListDispatch, useDashboardListStore } from "../../../contexts/DashboardListContext";
import { useDashboardUserSettingDispatch } from "../../../contexts/DashboardUserSettingsContext";

// returns a function that accepts a dash list object (includes list attributes) and whether or not to go to the edit page (false by default)
export function useWorkspaceDashboardSelection() {
  const { selectedAccount } = useAuthStore();
  const selectDashboardDispatch = useSelectedDashboardDispatch();
  const { createDashboardUserSetting } = useCreateDashboardUserSettings();
  const navigate = useNavigate();
  const workspaceDispatch = useWorkspaceDispatch();
  const { dashboardIds } = useDashboardListStore();
  const { user } = useAuthStore();
  const dashboardListDispatch = useDashboardListDispatch();
  const dashboardUserSettingDispatch = useDashboardUserSettingDispatch()


  const updateDUS = async(dashListObj) => {
    //update in DashboardUserSetting
    if (dashListObj) {
      try{
        const data = await createDashboardUserSetting({
          DashboardId: dashListObj.id,
          AccountId: selectedAccount.id,
          event: dashListObj.event,
          lastActionOn: new Date(),
        });
        const nonUserDUS = dashListObj.DashboardUserSettings.filter((dus) => dus.UserId !== user.id)
        dashboardUserSettingDispatch({ type: "updateDashboardUserSettings", payload: [data] });
        //first need to check if the dashboardusersetting with the same userId and DashboardId exists, if exsits, replace the lastAction on, other wise add DUS
        const existingDUS = dashListObj.DashboardUserSettings.find((dus) => dus.UserId === user.id && dus.DashboardId === dashListObj.id)
        let tmpDUS = {}
        let updateDashObj = {}
        if(existingDUS){
          tmpDUS = { ...existingDUS, lastActionOn: data.lastActionOn}
          updateDashObj = { ...dashListObj, DashboardUserSettings: [...nonUserDUS, tmpDUS] }
        }else{
          tmpDUS = {
            id: data.id,
            DashboardId: data.DashboardId,
            UserId: data.UserId,
            DashboardPermissionId: data.DashboardPermissionId,
            lastActionOn: data.lastActionOn
          }
          updateDashObj = { ...dashListObj, DashboardUserSettings: [...nonUserDUS, tmpDUS]}
        }
        dashboardListDispatch({
          type: "updateDashboard",
          payload: updateDashObj,
        });
        dashboardListDispatch({
          type: "moveIdToTopOfList",
          payload: dashListObj.id,
        });
      }catch(error){
        console.error("Error creating dashboarduseretting:", error);
      }
    }
  }
  

    // if selecting a dash to view setSelected(dash)
    // if selecting a dash to edit setSelected(dash,"/edit")
    // if selecting a dash, no redirect setSelected(dash, null)
    // if selecting no dash (group) setSelected(null);

  async function setSelected(dashListObj, navigation = "/", createdDash = false) {
    // Optimistically navigate
    if (navigation && navigation.toLowerCase().includes("marketplace")) {
      navigate(navigation)
    } else if (navigation) {
      navigate(`/workspace${dashListObj ? "/dashboard/" + dashListObj.uniqueHash + navigation : navigation}`);
    }

    // Update state optimistically
    selectDashboardDispatch({
      type: "setSelectedDashboardId",
      payload: dashListObj?.id,
    });
    selectDashboardDispatch({
      type: "setSelectedDashboardHash",
      payload: dashListObj?.uniqueHash,
    });
    // Exit early if nothing was updated
    if (dashListObj?.skipUpdate) {
      return
    }
    // Update user settings in the background
    if (!(navigation && navigation.toLowerCase().includes("marketplace"))) {
      updateDUS(dashListObj).catch((error) => {
        console.error("Error updating dashboard user settings:", error);
      });
    }else if (createdDash && dashListObj && dashListObj.TemplateId) {
      updateDUS(dashListObj).catch((error) => {
        console.error("Error updating dashboard user settings for created dashboard:", error);
      });

      dashboardListDispatch({ type: "setDashboardIds", payload: [dashListObj.id, ...dashboardIds] });
      workspaceDispatch({ type: "setIsRecentsOpen", payload: true });
    }
  }
    
  return setSelected
}
